import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolClassesLevel = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-5 md:col-span-6">
          <Image
            width={270}
            height={211}
            className="flex-image"
            src="/images/courses.png"
            alt="Course Image"
          />
        </div>
        <div className="col-span-12 lg:col-span-7 md:col-span-6 col-center-sm">
          <h2 className="school-section-title h3">
            {t(
              'service.school.effectiveClasses.explanations.title.basedOnLevel',
            )}
          </h2>
          <p className="school-section-description">
            {t(
              'service.school.effectiveClasses.explanations.detail.basedOnLevel',
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolClassesLevel;
